import 'styles/app.scss';
import { Container } from 'react-bootstrap';
import Profile from 'components/Profile';
import { useEffect, useState } from 'react';
import Loading from 'components/Loading';

function App() {
    const [data, setData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(
                    'https://api.myjson.online/v1/records/00ae4ab1-2b74-4bc5-8991-f60ff9761304',
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'm-collection-access-token':
                                '14fd5407-a000-42bb-92d8-a885c8f90f8b',
                        },
                    }
                );
                const json = await response.json();
                setData(json.data);
            } catch (error) {
                console.log('error', error);
            }
        };
        fetchData();
    }, []);

    return (
        <Container>
            <Loading show={!data}>
            {data && <Profile data={data} />}
            </Loading>
        </Container>
    );
}

export default App;
